

import {  useEffect, useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import {  loginSuccessP } from "../redux/slices/pensSlice";

import apiService from "../api/ApiService";
import { useForm } from "react-hook-form";
import { isEqual } from "./EditModalDam";
import { Category, Close, Title } from "@mui/icons-material";
const moment=require('moment-jalaali');


const EditPen=({penr,allPenss,iindex})=>{
    const {currentPens}=useSelector(state=>state.pens)
    const [valid,setValid]=useState(false)
    
    
    const [allPens,setAllPens]=useState(allPenss)
    const {openModalls,isOpenModal,closeModalls}=useGlobalContext();
    const mainProp={
        name:penr?.name,type:penr.penTypeId
      }
    const dispatch=useDispatch();
    const {watch,
        register,
        handleSubmit,
        formState: { errors }
      } = useForm({defaultValues:mainProp});
    
    const getTypePens=async()=>{

        const res=await apiService.getTypePens({'isActive':true});
        const filt=res.data.filter(item=>{
            return item.id!==penr.penTypeId
        })
        setAllPens(filt)
        
    }
    useEffect(()=>{
        getTypePens()
    },[])
    const allData=watch()
    useEffect(()=>{setValid(isEqual(mainProp,allData))},[allData])


    

    const updatePen=async(data)=>{           
                    const data1=JSON.stringify({...data,type:+data?.type})
                    const res=await apiService.updatePen(penr.id,data1);
                    const editedList = [
                        ...currentPens.slice(0,iindex),
                        res.data,
                        ...currentPens.slice(iindex+1)
                      ];
                    dispatch(loginSuccessP([...editedList]))
                    openModalls()
    }
    

    return <div onClick={closeModalls} className={`modal-overlay ${isOpenModal&&'show-modal'} `}>
        <form onSubmit={handleSubmit(updatePen)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <DriveFileRenameOutlineIcon fontSize="large"/>

            <h4 >به روز رسانی بهاربند</h4>
            </div>
       
            <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("name",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><Title fontSize="small"/> نام بهاربند</label>
            {errors?.name?.message&&<span className='errMsg'>{errors.name.message}</span>}
        </div>
        <div className="SelConn">
        <label for='sele' ><Category fontSize="small"/> دسته:</label>
        <select id='sele' name='sele' className="selectInp" {...register("type",{required:'این مقدار ضروری است'})}>
        <option  value={penr.penTypeId}>{penr.penTypeTitle}</option>
            {
                allPens.map((item,index)=>{
                        return <option key={index} value={item.id}>{item.title}</option>
                })

            }
        </select>
        {errors?.type?.message&&<span className='errMsg'>{errors.type.message}</span>}
        </div>
        <button disabled={valid} className="EditMOdalBtnForm" type="submit">
            تایید
        </button>
        
        </form>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
    </div>
}
export default EditPen